module.exports = __webpack_public_path__ + "img/movie9.03087f02.png";